var render = function render(){var _vm=this,_c=_vm._self._c;return _c('masked-input',{ref:"input",attrs:{"type":"text","mask":_vm.createNumberMask,"guide":false,"value":_vm.internalValue},on:{"input":_vm.updateValue,"focus":function($event){return _vm.$emit('focus')},"blur":_vm.onBlur,"keyup":function($event){return _vm.$emit('keyup')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }